import React, { createRef, useEffect, useRef, useState } from "react";
import {Button, Collapse, ConfigProvider, Form, Input, Space, Spin, Table, Tabs, Tooltip} from "antd";
const { TabPane } = Tabs;
const { Panel } = Collapse;

import { getAccountOperations, AccountOperations, AccountOperationFilters, getAccounts } from "../../../services/account";
import { getCurrentCompany } from "../../../services/user";

import { ReloadOutlined } from "@ant-design/icons";
import {
    DownloadDocIco,
    AccountDownloadIco,
    ArrowUpIco,
    ArrowDownIco,
    ReloadIco,
    LoadMoreIcon, TabsInfoIco
} from "../../../../modules/CustomIcons";
import { Spinner } from "constants/constants";
import { addStr, addStrAccountOperation, dateFormatter, financial } from "../../../services/helper";
import SelectField from "components/SelectField";
import TableComponent from "components/Table";
import SearchableColumn from "components/Table/ColumnSearch";
import CustomTooltip from "components/Tooltip";
import { getPaymentOrderPdfByIbanRef } from "../../../services/MassTransfers/MassTransferFile";
import FullScreenLoading from "components/FullScreenLoading";
import { getTrannsferByIban } from "../../../services/Transfers/transfers";
import { redirectPage, redirectPageWithType } from "pages/Transfers/TypeStatusRender";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {CustomDataEmpty} from "components/customDataEmpty";
import { useTranslation } from "react-i18next";
import messageList from "assets/locales/translate.json";
import {getMessageLists} from "store/actions/home";


const AccountOperationsComponent: React.FC<any> = ({ accountLoading, messageList, isCompChange }) => {
    const {t} = useTranslation();
    const [tableShowLimit, setTableShowLimit] = useState(20);
    const [tableLoading, setTableLoading] = useState(Spinner)
    const [filterDateTime, setFilterDateTime] = useState(dateFormatter());
    const [open, setOpen] = useState(["0"]);
    const [dateFilterListMain, setDateFilterListMain] = useState<Array<any>>([]);
    const [dateFilterList, setDateFilterList] = useState<Array<any>>([]);
    const [dateList, setDateList] = useState([{ label: t("common.all"), value: 'all' }]);
    const [form] = Form.useForm();
    const [page, setPage] = useState(1);
    const [activeKeyData, setActiveKeyData] = useState("both");
    const [reloadPage, setReloadPage] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(0);
    const history = useHistory()
    const [loading, setLoading] = useState(false);
    const [textArray, setTextArray] = useState([])
    const language = localStorage.getItem("i18nextLng")

    const fetchData = async () => {
        try{
            // setLoading(true)
            setTableLoading({
                ...tableLoading,
                spinning: true
            });


            const data = await getAccountOperations(getCurrentCompany(), {page: page, activeKey: activeKeyData}, open);
            // const filterData = data?.filter(row => (activeKey == 'CR' || activeKey == 'DR') ? row.debit_credit_flag == activeKey : row)

            let temp_array = [];
            let temp_dates = [];

            // setDateFilterListMain(old_data => []);

            for (let row of data) {
                let create_date = dateFormatter(`${row.trn_date} ${row.trn_time}`);

                let filter_date = dateFormatter(row.trn_date, "DD.MM.YYYY");

                let check_date = temp_dates.find(row => row.value == filter_date);
                let check_date2 = dateList.find(row => row.value == filter_date);

                if (!check_date && !check_date2) {
                    temp_dates.push({label: filter_date, value: filter_date})
                }


                // @ts-ignore
                temp_array.push({
                    key: row.trnCaller,
                    col_1: create_date,
                    col_2: {
                        amount: financial(row.amount),
                        debit_credit_flag: row.debit_credit_flag,
                        currency: row.currency_name
                    },
                    col_3: row.receiver_name,
                    col_4: row.descrption,
                    col_5: {
                        label: addStr(row.account_iban),
                        tooltip: row.account_nickname ? row.account_nickname : row.account_product
                    },
                    row: row
                });
            }


            setTableLoading({
                ...tableLoading,
                spinning: false
            });
            setFilterDateTime(old_data => dateFormatter())
            // setDateFilterListMain(old_data => temp_array)
            // setDateFilterList(old_data => temp_array)
            if (page === 1) {
                setDateFilterList(old_data => temp_array)
                setDateFilterListMain(temp_array)
                setDateList(temp_dates)
            } else {
                setDateFilterList([...dateFilterList, ...temp_array]);
                setDateFilterListMain([...dateFilterListMain, ...temp_array])
                setDateList([...dateList, ...temp_dates])
            }
            // setLoading(false)

            let lang_text = messageList?.result !== undefined ? (language == "az" ? messageList.result.find(text=> text.messageKey === 'INFO.LAST_TRANSACTION')?.textAZE :
                language == "ru" ? messageList.result.find(text=> text.messageKey === 'INFO.LAST_TRANSACTION')?.textRU : language == "en" ? messageList.result.find(text=> text.messageKey === 'INFO.LAST_TRANSACTION')?.textENG : "") : "";
            const array = lang_text !== null && lang_text !== undefined  ? lang_text.split("|") : [];
            setTextArray(array);
        }catch(e){
            // setLoading(false)
            setTableLoading({
                ...tableLoading,
                spinning: false
            });
        }
    };

    const ToolTipMessage = () => {

        return(
            textArray.map((line:any,index:number) => {

                return(

                    line.startsWith('http') ?
                        `<a href=${line} key=${index} > ${line} </a>`
                        :
                        `<p key=${index}> ${line} </p>`
                )
            }).join(''))
    }

    useEffect(() => {
        if(!isCompChange) {
            fetchData();
        }
    }, [getCurrentCompany().customerNo, page, activeKeyData, reloadPage, isCompChange,messageList,language,open]);

    useEffect(() => {
        if (accountLoading && !isCompChange) {
            fetchData();
        }
    }, [accountLoading, isCompChange]);

    const searchInput = useRef();

    const collapseHeader = () => (
        <p >{t("home.lastTransaction")}
            <CustomTooltip
                title={ToolTipMessage() }
            >
                <Button
                    style={{borderRight: "1px solid #d9e3ec",height:'100%',alignItems:"center"}}

                    type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
            </CustomTooltip>
        </p>
    );

    const reloadData = () => {
        setReloadPage(!reloadPage)
        setPage(1)
        setDateFilterList([])
        setDateFilterListMain([])
        setDateList([{ label: t("common.all"), value: 'all' }])
        form.setFieldsValue({
            ['date_filter']: { label: t("common.all"), value: 'all' },
        })
        setButtonClicked(buttonClicked + 1);
    }

    const collapseExtra = () => (
        <>
            <Button icon={<ReloadIco />} onClick={() => { reloadData() }} className='transparent box_reload_ico' />

            <span>{filterDateTime}</span>
        </>
    );

    const rowClassName = (record: any, index: number) => {
        return index % 2 ? 'table-row-light' : 'table-row-dark';
    }

    const openCloseCollapse = () => {
        setOpen(prev => prev.indexOf(1) != -1 ? [0] : [1]);
    }

    const tabsChange = (activeKey) => {
        setPage(1)
        setDateFilterList([])
        setDateFilterListMain([])
        setDateList([{ label: t("common.all"), value: 'all' }])
        setActiveKeyData(activeKey)
        form.setFieldsValue({
            ['date_filter']: { label: t("common.all"), value: 'all' },
        })
        setButtonClicked(buttonClicked + 1);
        // fetchData(activeKey);
    }

    const [filtereValues, setFilteredValues] = useState({ "col_1": "", "col_2": "", "col_3": "", "col_4": "", "col_5": "" })

    const handleFilterColumn = (e: any, column: string) => {

        let newfiltereValues = filtereValues;

        if (column === 'col_1') {
            newfiltereValues.col_1 = e?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_2') {
            newfiltereValues.col_2 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_3') {
            newfiltereValues.col_3 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_4') {
            newfiltereValues.col_4 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_5') {
            newfiltereValues.col_5 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (dateFilterListMain && filtereValues) {

            let filteredData;
            filteredData = dateFilterListMain?.filter(sRow => sRow.col_1.split(' ')[0].toLowerCase().includes(filtereValues["col_1"]) && sRow.col_2.amount?.toLowerCase().includes(filtereValues["col_2"]) && (sRow.col_3 ? sRow.col_3?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_3"]) : filtereValues["col_3"] === '' ? sRow.col_3 === undefined : "") && sRow.col_4?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]) && sRow.col_5.label?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_5"]));

            setDateFilterList(filteredData)

            if (filtereValues["col_1"] === "all") {
                form.resetFields(['date_filter']);
            }
        }
    }

    const downloadPdf = async (record) => {
        let singlePdf: Array<any> = []
        singlePdf.push({
            ibankRef: record?.row?.ibankRef
        })
        const data = await getPaymentOrderPdfByIbanRef(language,record.row.ibankRef)
        let pdfresult = data?.data?.fileDetailsList
        pdfresult.map((item: any) => {
            return downloadPDFFile(item.fileName, item.fileBase64)
        })
    }

    function downloadPDFFile(fileName: string, fileBase64: string) {
        const linkSource = `data:$application/download;base64,${fileBase64}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
    }

    const loadMore = () => {
        // setTableShowLimit(old_count => old_count + 20);
        setPage((page) => page + 1);
    }

    const handleRepeat = async (record) => {
        const result = await getTrannsferByIban(record?.row?.ibankRef)
        let type = redirectPageWithType(result?.trnType)
        if (type !== "")
            history.push(`${type}`, { data: result })
    }

    // @ts-ignore
    const accountTableColumns = [
        {
            title: (
                <>
                    <SelectField
                        placeholder={t("common.date")}
                        options={dateList}
                        className="status-select"
                        onChange={(event: any) => handleFilterColumn(event, 'col_1')}
                        name={'date_filter'}
                        // height={dateFilterList.length >1 ? '100px' : '60px'}
                    />
                </>
            ),
            dataIndex: 'col_1',
            key: 'col_1',
            className: 'col_1',
            render: data => (
                <>
                    <p>{data}</p>
                </>
            ),
            ellipsis: true,
            width: 103,
            editable: false,
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"amount"}
                            filter={"searchfilter"}
                            title={t("common.amount")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_2')}
                            buttonClicked={buttonClicked}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_2',
            key: 'col_2',
            className: ' col_2',
            ellipsis: true,
            width: 130,
            editable: false,
            render: (text, record) => {
                let class_name = (text.debit_credit_flag === 'DR') ? 'is_red' : 'is_blue';
                let minus = text.debit_credit_flag === 'DR' ? '-' : '';
                return (
                    <p className={`${class_name}`} style={{ textAlign: "right" }}>{minus}{text.amount} {text.currency}</p>
                )
            }
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            large
                            form={form}
                            name={"senderReceiver"}
                            filter={"searchfilter"}
                            title={t("home.senderReceiver")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_3')}
                            buttonClicked={buttonClicked}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_3',
            key: 'col_3',
            className: 'col_3',
            ellipsis: true,
            width: 230,
            editable: false,
            render: (text, record) => {
                let check_text = text || '';
                return check_text.toString().length > 22 ?
                    <CustomTooltip title={text} className={'tooltip_slim'}>
                        <p >{text?.substring(0,22)+'...'}</p>
                    </CustomTooltip>
                    : <p >{text?.substring(0,22)+'...'}</p>
            }
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            large
                            form={form}
                            name={"operationDescription"}
                            filter={"searchfilter"}
                            title={t("home.paymentDetails")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_4')}
                            buttonClicked={buttonClicked}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_4',
            key: 'col_4',
            className: 'col_4',
            ellipsis: true,
            width: 250,
            editable: false,
            render: (text: string) => {
                let check_text = text || '';
                return check_text.toString().length > 29 ?
                    <CustomTooltip title={text} className={'tooltip_slim'}>
                        <p >{addStrAccountOperation(text)}</p>
                    </CustomTooltip>
                    : <p >{text}</p>
            }
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            large
                            form={form}
                            name={"account"}
                            filter={"searchfilter"}
                            title={t("home.account")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_5')}
                            buttonClicked={buttonClicked}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_5',
            key: 'col_5',
            className: 'col_5',
            ellipsis: true,
            width: 209,
            editable: false,
            render: (text, record) => {

                return <CustomTooltip title={text.tooltip} className={'tooltip_slim'}>
                    <p >{addStr(text.label)}</p>
                </CustomTooltip>
            }
        },
        {
            title: '',
            key: 'action',
            className: 'col_6',
            ellipsis: true,
            width: 100,
            editable: false,
            render: (text, record) => ("ibankRef" in record.row) && record.row.ibankRef !== null ? (
                <div className='flex align_center justify_end account_operation_table_button'>
                    {/* <CustomTooltip title={t("transfers.downloadSWIFTConfirmation")}>
                        <Button icon={<AccountDownloadIco />} className='transparent box_reload_ico' />
                    </CustomTooltip> */}

                    <CustomTooltip title={t("home.repeat")}>
                        <Button icon={<ReloadOutlined />} onClick={() => handleRepeat(record)} className='transparent box_reload_ico table_reload_btn' />
                    </CustomTooltip>

                    <CustomTooltip title={t("home.downloadOrderPayment")}>
                        <Button icon={<DownloadDocIco />} onClick={() => downloadPdf(record)} className='transparent table_download_btn' />
                    </CustomTooltip>
                </div>
            ) : (<></>),
        },
    ];

    const tableContent = <div className={'full direction_column align_center'}>
            <TableComponent
            // loading={tableLoading}
            columns={accountTableColumns}
            className="transfer-table table-hover salary-table  home_hesab_table home_account_operation_table"
            data={dateFilterList}
            scroll={{x: true}}
            pagination={false}
            pageSize={3}
            position={'center'}
            alignment={'bottom'}
            rowClassName={rowClassName}
        />
        { dateFilterListMain?.length == 0 && !loading ? <div style={{marginBottom: '30px'}}><CustomDataEmpty value={t("home.operationnotfound")}  /></div> : <div></div> }

        {
            dateFilterList.length > 0 && dateFilterList.length % 20 === 0 ? <Button
                type={"ghost"}
                className={'flex align_center justify_center table_load_more'}
                icon={<LoadMoreIcon />}
                onClick={() => loadMore()}
            /> : <></>
        }

        {/* {
            dateFilterList.length > 20 && tableShowLimit < dateFilterList.length && <Button
                type={"ghost"}
                className={'flex align_center justify_center table_load_more'}
                icon={<LoadMoreIcon />}
                onClick={() => loadMore()}
            />
        } */}
    </div>;

    return (
        <Spin {...tableLoading}>
            <Collapse
                expandIcon={(panelProps) => <Button type={"ghost"} className={'transparent'} icon={panelProps.isActive ? <ArrowUpIco className={'cursor_pointer'} /> : <ArrowDownIco className={'cursor_pointer'} />} />}
                activeKey={open}
                onChange={openCloseCollapse}
                expandIconPosition={'end'}
                className='home_page_collapse home_page_hesab_collapse home_page_hesab_operation_collapse'
            >
                <Panel
                    header={collapseHeader()}
                    key="1"
                    // onChange={openCloseCollapse}
                    // onClick={openCloseCollapse}
                    extra={collapseExtra()}
                    collapsible={'header'}
                    className={'accOp'}
                >

                    <Tabs
                        defaultActiveKey="both"
                        className='currency_tabs hesab_tabs'
                        onChange={tabsChange}

                        tabBarExtraContent={<p className={'ac_opt_show_count'} >{t("home.count")}: <span>{dateFilterList.length}</span></p>}
                    >

                        <TabPane tab={t("common.all")} key="both">

                            <Form
                                form={form}
                            >
                                {tableContent}
                            </Form>

                        </TabPane>

                        <TabPane tab={t("home.incoming")} key="CR">
                            <Form
                                form={form}
                            >
                                {tableContent}
                            </Form>
                        </TabPane>

                        <TabPane tab={t("home.outcoming")} key="DR">
                            <Form
                                form={form}
                            >
                                {tableContent}
                            </Form>
                        </TabPane>
                    </Tabs>
                </Panel>
            </Collapse>
            {/*{*/}
            {/*    tableLoading.spinning ? <FullScreenLoading /> : <></>*/}
            {/*}*/}
        </Spin>
    )
}

const mapDispatchToProps = {
   getMessageLists
}
const mapStateToProps = (state: any) => ({
    accountLoading: state.accountsStatement.accountLoading,
    messageList:state.home.messageList,
    isCompChange: state.user.isCompChange,
})

export default connect(mapStateToProps, mapDispatchToProps)(AccountOperationsComponent)
